import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import { blue } from "@material-ui/core/colors";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
});

export default function ConfirmDialog({ onClose, open, data }) {
  const classes = useStyles();

  const handleOnClose = (value) => {
    onClose();
    if (data.onConfirm) {
      data.onConfirm(value);
    }
  }

  return (
    <Dialog
      onClose={() => handleOnClose(false)}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      {data && data.title && (
        <DialogTitle id="simple-dialog-title">{data.title}</DialogTitle>
      )}

      <DialogContent dividers={true}>
        {data && (
          <div
            className=""
            dangerouslySetInnerHTML={{ __html: data.body }}
          ></div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleOnClose(false)} color="primary">
          {data && data.noText ? data.noText : "Close"}
        </Button>
        <Button onClick={() => handleOnClose(true)} color="primary">
          {data && data.yesText ? data.yesText : "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
